import React from "react";
import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { CheckCircle } from "@mui/icons-material";

function getUnderwritingBannerIconColor(status, isApproved) {
  if (isApproved) {
    return "success.main";
  }
  if (["pending", "rejected"].includes(status)) {
    return "error.main";
  }
  return "warning.main";
}

function getUnderwritingBannerStatusMessage(data, status) {
  if (status === "overrided") {
    if (data.overrided_by?.trim() || data.overrided_at) {
      const overridedAt = data.overrided_at
        ? new Date(data.overrided_at).toLocaleString()
        : "";
      return `Not Required (Overrided by ${(data.overrided_by || "").trim()} at ${overridedAt})`;
    }
    return "Not Required";
  }
  if (status) {
    return status.charAt(0).toUpperCase() + status.slice(1);
  }
  return "";
}

/**
 * Shared underwriting status banner on bond retrieve pages (Phase 14).
 */
export function BondRetrievalUnderwritingBanner({ data, role }) {
  if (
    !data?.underwriting_status ||
    data.underwriting_status?.trim()?.toLowerCase() === "not required" ||
    !(role === "super_user" || role === "internal_user")
  ) {
    return null;
  }

  const status = data.underwriting_status?.trim()?.toLowerCase();
  const isApproved = ["approved", "overrided"].includes(status);

  return (
    <Box
      sx={{
        width: "100%",
        mb: 2,
        p: 2,
        backgroundColor: "#f5f5f5",
        borderRadius: 1,
        border: "1px solid #e0e0e0",
        display: "flex",
        alignItems: "flex-start",
        gap: 1.5,
      }}
    >
      <Box
        sx={{
          color: getUnderwritingBannerIconColor(status, isApproved),
          mt: 0.25,
        }}
      >
        {isApproved ? (
          <CheckCircle fontSize="small" />
        ) : (
          <InfoOutlinedIcon fontSize="small" />
        )}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="subtitle2" fontWeight={700} color="text.primary" sx={{ mb: 0.5 }}>
          Underwriting
        </Typography>
        <Typography variant="body2" color="text.secondary" component="div">
          <div>
            <span style={{ fontWeight: 700 }}>Status:</span>{" "}
            <span style={{ fontWeight: 400, color: "inherit" }}>
              {getUnderwritingBannerStatusMessage(data, status)}
            </span>
          </div>
          {status === "overrided" && (data.override_reason || "").trim() && (
            <div>
              <span style={{ fontWeight: 700 }}>Override reason:</span>{" "}
              <span style={{ fontWeight: 400 }}>{(data.override_reason || "").trim()}</span>
            </div>
          )}
          {status !== "overrided" &&
            status !== "not required" &&
            data.underwriting_reason && (
              <div>Reason for Trigger: {data.underwriting_reason}</div>
            )}
        </Typography>
      </Box>
    </Box>
  );
}
